<mat-card class="row-margin-tb card-dark">
    <mat-card class="card">
        <app-allocation-form></app-allocation-form>
        <app-allocation-list></app-allocation-list>
    </mat-card>
</mat-card>